export default {
	properties: [
		{
			text: 'Metodo de pago',
			key: 'current_acount_payment_method_id',
			type: 'select',
			use_store_models: true,
		},
	],
	singular_model_name_spanish: 'Metodo de pago seleccionado para Facturacion',
	plural_model_name_spanish: 'Metodo de pago seleccionado para Facturacion',
	create_model_name_spanish: 'Nuevo Metodo de pago seleccionado para Facturacion',
	text_delete: 'el',
}